module.exports = __webpack_public_path__ + "static/media/screen1.0e8c2c3d.png";